import SettingsDialog from '../../../sharedComponents/src/settings/SettingsDialog'
import { useStoreActions, useStoreState } from '../../../store/hooks'

export const Settings = () => {
    const setOverlayTrigger = useStoreActions((state) => state.setOverlayTrigger)
    const setSettings = useStoreActions((state) => state.gameView.setSettings)

    const setUserData = useStoreActions((state) => state.setUserData)

    const userData = useStoreState((state) => state.userData)

    const onSettingsChange = (updatedSettings) => {
        setSettings(updatedSettings)
        if (userData.userData) {
            setUserData({ ...userData, userData: { ...userData.userData, game_settings: updatedSettings } })
        }
    }

    if (!userData.userData) return null

    return (
        <SettingsDialog
            fullScreenView
            settings={userData.userData.game_settings}
            groups={userData.userData.groups}
            openJoinUsForm={() => setOverlayTrigger('joinUs')}
            setSettings={onSettingsChange}
            onClose={() => setOverlayTrigger('')}
        />
    )
}
